import { useState, useEffect, useMemo } from "react";

export function useFilter(data, filters = {}, options = {}) {
  const { delay = 300, defaultFilter } = options;
  const [debouncedFilters, setDebouncedFilters] = useState(filters);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedFilters(filters);
    }, delay);

    return () => clearTimeout(handler);
  }, [filters, delay]);

  return useMemo(() => {
    let filteredData = data;

    if (defaultFilter && typeof defaultFilter === "function") {
      filteredData = filteredData?.filter(defaultFilter);
    }

    if (debouncedFilters && Object.keys(debouncedFilters).length > 0) {
      filteredData = filteredData?.filter((item) =>
        Object.entries(debouncedFilters).every(([key, value]) => {
          if (value == null || value === "") return true;

          const itemValue = getNestedValue(item, key);
          return (
            String(itemValue ?? "").toLowerCase() ===
            String(value).toLowerCase()
          );
        })
      );
    }

    return filteredData;
  }, [data, debouncedFilters, defaultFilter]);
}

function getNestedValue(obj, path) {
  return path.split(".").reduce((acc, part) => {
    if (acc && typeof acc === "object") {
      return acc[part];
    }
    return undefined;
  }, obj);
}

// export function useFilter(data, filters = {}, options = {}) {
//   const { delay = 300, defaultFilter } = options;
//   const [debouncedFilters, setDebouncedFilters] = useState(filters);

//   // debounce filters
//   useEffect(() => {
//     const handler = setTimeout(() => {
//       setDebouncedFilters(filters);
//     }, delay);

//     return () => clearTimeout(handler);
//   }, [filters, delay]);

//   return useMemo(() => {
//     let filteredData = data;

//     if (defaultFilter && typeof defaultFilter === "function") {
//       filteredData = filteredData?.filter(defaultFilter);
//     }

//     if (debouncedFilters && Object.keys(debouncedFilters).length > 0) {
//       filteredData = filteredData?.filter((item) =>
//         Object.entries(debouncedFilters).every(([key, value]) => {
//           if (value == null || value === "") return true;
//           return (
//             String(item?.[key] ?? "").toLowerCase() ===
//             String(value).toLowerCase()
//           );
//         })
//       );
//     }

//     return filteredData;
//   }, [data, debouncedFilters, defaultFilter]);
// }
